import { render, staticRenderFns } from "./FeedListItem.vue?vue&type=template&id=8e07e994&scoped=true"
import script from "./FeedListItem.vue?vue&type=script&lang=ts"
export * from "./FeedListItem.vue?vue&type=script&lang=ts"
import style0 from "./FeedListItem.vue?vue&type=style&index=0&id=8e07e994&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e07e994",
  null
  
)

export default component.exports